import { render, staticRenderFns } from "./empty-bookings-found.vue?vue&type=template&id=59f905b2&scoped=true&"
import script from "./empty-bookings-found.vue?vue&type=script&lang=js&"
export * from "./empty-bookings-found.vue?vue&type=script&lang=js&"
import style0 from "./empty-bookings-found.vue?vue&type=style&index=0&id=59f905b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f905b2",
  null
  
)

export default component.exports